import Base from '../BaseRouteArrivalTime';

const RouteArrivalTime = ({nodeRef, ...props}) => (
    <Base {...props}>
        <div className="route-arrival-time-marker" ref={nodeRef} />
    </Base>
);

export default RouteArrivalTime;
